import BasicInfo from './BasicInfo.vue'
import Stepper from './Stepper.vue'

export const routes = [{
  path: '/info',
  component: Stepper,
}]
